import React from "react";
import axios from "axios";
import { Question } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fire-and-forget ping so we can see which screens confuse users most.
export const pingHelpClick = (feature, source = "header") => {
  try { axios.post(`${API}/analytics/help-click`, { feature, source }).catch(() => {}); } catch (e) { /* ignore */ }
};

// Small contextual "?" icon for feature headers. Clicking jumps to the Guide
// tab, pre-scrolled and briefly highlighting that feature's section.
const GuideHelpButton = ({ feature, label = "How this works", className = "" }) => (
  <button
    type="button"
    onClick={() => {
      pingHelpClick(feature, "header");
      window.dispatchEvent(new CustomEvent("pp:open-guide", { detail: { feature } }));
    }}
    data-testid={`guide-help-${feature}`}
    title={label}
    aria-label={label}
    className={`inline-flex items-center justify-center w-7 h-7 rounded-full border border-zinc-200 text-zinc-400 hover:text-violet-700 hover:border-violet-300 hover:bg-violet-50 transition-colors ${className}`}
  >
    <Question size={15} weight="bold" />
  </button>
);

export default GuideHelpButton;
